<template>
  <div class="home-container">
    <!-- Title Card -->
    <div>
      <div class="title-card">
        <h1 class="home-title">Arina East Residences</h1>
        <p class="home-subtitle">Where Luxury Meets Sophistication</p>
      </div>

      <!-- Buttons -->
      <div class="button-container">
        <v-btn color="primary" class="action-button" @click="scrollToSection('enquire')">
          Find Out More
        </v-btn>
        <v-btn color="secondary" class="action-button" @click="scrollToSection('enquire')">
          Get VVIP Access Today
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomeView',
  props: {
    scrollToSection: Function, // Define the prop to accept the method
  },
});
</script>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  background-image: url("@/assets/1_Homeview.png");
  background-size: cover;
  background-position: center;
}

/* Translucent Title Card */
.title-card {
  background: rgba(0, 0, 0, 0.5);
  /* Semi-transparent black */
  padding: 20px 40px;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 30px;
}

.home-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #FFFFFF;
  margin-bottom: 10px;
}

.home-subtitle {
  font-size: 1.2rem;
  color: #FFF;
}

.button-container {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
}

.action-button {
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


/* Responsive Adjustments */
@media (max-width: 600px) {
  .home-title {
    font-size: 2rem;
  }

  .home-subtitle {
    font-size: 1rem;
  }

  .title-card {
    padding: 15px 30px;
    max-width: 100%;
  }

  .button-container {
    flex-direction: column;
    gap: 10px;
  }

  .action-button {
    width: 100%;
    font-size: 0.9rem;
    padding: 10px 20px;
  }
}
</style>
